export default {
  statistics: {
    total_campaigns: 'Total de campanhas',
    todays_sent_messages: 'Mensagens enviadas hoje',
    total_subscribers: 'Subscritores',
    average_click_rate: 'Taxa média de cliques',
  },
};
